<template>
  <v-container>
    <v-card-title v-if="!failed">
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-data-table
        v-if="!failed"
        :headers="headers"
        :items="colors"
        :search="search"
        class="elevation-1"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title>COLORS</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialogAdd" width="500px">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  outlined
                  color="success"
                  class="mb-2"
                  v-bind="attrs"
                  v-on="on"
                >
                  Add color
                  <v-icon color="success">mdi-invert-colors</v-icon>
                </v-btn>
              </template>
              <v-card>
                <v-card-title class="headline footer basic--text">
                  <span>{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="6">
                        <v-text-field
                          v-model="editedItem.realColor"
                          label="Real Color"
                          :rules="[rules.required]"
                          outlined
                          dense
                        ></v-text-field>
                      </v-col>
                      <v-col cols="6">
                        <v-text-field
                          v-model="editedItem.colorMap"
                          label="Color Map"
                          :rules="[rules.required]"
                          outlined
                          dense
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="error" outlined @click="close"> Cancel </v-btn>
                  <v-btn color="success" outlined @click="save"> Save </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog v-model="dialogDelete" width="unset">
              <v-card>
                <v-card-title class="headline"
                  >Are you sure you want to delete color
                  {{ editedItem.realColor }} ?</v-card-title
                >
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="error" outlined @click="closeDelete"
                    >Cancel</v-btn
                  >
                  <v-btn color="success" outlined @click="deleteItemConfirm"
                    >OK</v-btn
                  >
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="fetchColors"> Reset </v-btn>
        </template>
      </v-data-table>
    </v-form>

    <!-----------------STATUS DIALOG, WHEN WORKING WITH COLORS--------------------------->
    <v-dialog persistent v-model="statusDialog" width="unset">
      <status-info
        :responseMessage="responseMessage"
        :filename="filename"
        :pending="pending"
        @close="closeStatusDialog"
      ></status-info>
    </v-dialog>
    <!------------------------------------------------------------------------------------>

    <!-----------------IF SERVER IS COMPLETELY DOWN--------------------------------------->
    <status-info
      v-if="failed && filename !== ''"
      :responseMessage="responseMessage"
      :filename="filename"
    >
    </status-info>
    <!----------------------------------------------------------------------------------->
  </v-container>
</template>

<script>
import axios from "axios";
import StatusInfo from "../organisms/StatusInfo";

export default {
  name: "Colors",
  components: {
    StatusInfo,
  },
  data: () => ({
    search: "",
    headers: [
      {
        text: "Real Color",
        align: "start",
        sortable: false,
        value: "realColor",
      },
      { text: "Color Map", value: "colorMap", sortable: false },
      { text: "Actions", value: "actions", sortable: false },
    ],
    rules: {
      required: (value) => !!value || "Field is required.",
    },
    valid: true,
    colors: [],
    dialogAdd: false,
    dialogDelete: false,
    editedIndex: -1,
    editedItem: {
      realColor: "",
      colorMap: "",
    },
    defaultItem: {
      realColor: "",
      colorMap: "",
    },
    errors: [],
    responseMessage: "",
    filename: "",
    failed: false,
    statusDialog: false,
    pending: false,
  }),
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New color" : "Edit color";
    },
  },
  watch: {
    dialogAdd(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },
  methods: {
    fetchColors() {
      // getting colors from server
      axios
        .get("api/colors")
        .then((response) => (this.colors = response.data))
        .catch((error) => {
          this.errors.push(error);
          switch (error.response.status) {
            case 400:
              this.filename = "empty.svg";
              this.failed = true;
              this.responseMessage =
                "Sorry, something went wrong, please contact TECH team!";
              break;
            case 401:
              //clear local storage, push to login
              localStorage.clear();
              this.$router.push("login");
              break;
            case 403:
              this.filename = "403_forbidden.svg";
              this.failed = true;
              this.responseMessage =
                "Sorry, you are forbidden to do this action!";
              break;
            case 500:
              this.filename = "server_down.svg";
              this.failed = true;
              this.responseMessage =
                "Internal server error, please contact TECH team!";
          }
        });
    },
    editItem(item) {
      this.editedIndex = this.colors.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogAdd = true;
    },

    deleteItem(item) {
      this.editedIndex = this.colors.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },
    deleteItemConfirm() {
      this.dialogDelete = false;
      this.pending = true;
      this.statusDialog = true;
      let color = this.editedItem.realColor;
      //deleting item
      axios
        .delete("api/color/" + this.editedItem.id)
        .then(() => {
          this.filename = "high_five.svg";
          this.responseMessage = "Success! Color " + color + " deleted!";
          this.pending = false;
        })
        .catch((error) => {
          switch (error.response.status) {
            case 400:
              this.pending = false;
              this.filename = "empty.svg";
              this.responseMessage =
                "Sorry, something went wrong, please contact TECH team!";
              break;
            case 401:
              //clear local storage, push to login
              localStorage.clear();
              this.$router.push("login");
              break;
            case 403:
              this.pending = false;
              this.filename = "403_forbidden.svg";
              this.responseMessage =
                "Sorry, you are forbidden to do this action!";
              break;
            case 500:
              this.pending = false;
              this.filename = "server_down.svg";
              this.responseMessage =
                "Internal server error, please contact TECH team!";
          }
        });
    },
    close() {
      this.dialogAdd = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    save() {
      if (this.$refs.form.validate()) {
        this.dialogAdd = false;
        this.pending = true;
        this.statusDialog = true;
        let color = this.editedItem.realColor;

        //editing item
        if (this.editedIndex > -1) {
          axios
            .put("api/color/" + this.editedItem.id, {
              realColor: this.editedItem.realColor,
              colorMap: this.editedItem.colorMap,
            })
            .then(() => {
              this.filename = "high_five.svg";
              this.responseMessage = "Success! Color " + color + " updated!";
              this.pending = false;
            })
            .catch((error) => {
              switch (error.response.status) {
                case 400:
                  this.pending = false;
                  this.filename = "empty.svg";
                  this.responseMessage =
                    "Sorry, something went wrong, please contact TECH team!";
                  break;
                case 401:
                  //clear local storage, push to login
                  localStorage.clear();
                  this.$router.push("login");
                  break;
                case 403:
                  this.pending = false;
                  this.filename = "403_forbidden.svg";
                  this.responseMessage =
                    "Sorry, you are forbidden to do this action!";
                  break;
                case 500:
                  this.pending = false;
                  this.filename = "server_down.svg";
                  this.responseMessage =
                    "Internal server error, please contact TECH team!";
              }
            });
        }
        //adding new item
        else {
          axios
            .post("api/color", {
              realColor: this.editedItem.realColor,
              colorMap: this.editedItem.colorMap,
            })
            .then(() => {
              this.filename = "high_five.svg";
              this.responseMessage = "Success! Color " + color + " added!";
              this.pending = false;
            })
            .catch((error) => {
              switch (error.response.status) {
                case 400:
                  this.pending = false;
                  this.filename = "empty.svg";
                  this.responseMessage =
                    "Sorry, something went wrong, please contact TECH team!";
                  break;
                case 401:
                  //clear local storage, push to login
                  localStorage.clear();
                  this.$router.push("login");
                  break;
                case 403:
                  this.pending = false;
                  this.filename = "403_forbidden.svg";
                  this.responseMessage =
                    "Sorry, you are forbidden to do this action!";
                  break;
                case 500:
                  this.pending = false;
                  this.filename = "server_down.svg";
                  this.responseMessage =
                    "Internal server error, please contact TECH team!";
              }
            });
        }
      }
    },
    closeStatusDialog() {
      this.statusDialog = false;
      this.fetchColors();
    },
  },
  created() {
    this.fetchColors();
  },
};
</script>